export default {
  FREE_SHIPPING: 'FREE_SHIPPING',
  LIMITED_EDITION: 'LIMITED_EDITION',
  FREE_RETURNS: 'FREE_RETURNS',
  FREE_SHIPPING_AND_RETURNS: 'FREE_SHIPPING_AND_RETURNS'
};
